import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-salesbyclient',
  templateUrl: './salesbyclient.component.html',
  styleUrls: ['./salesbyclient.component.css']
})
export class SalesbyclientComponent extends BaseCrudComponent {

  	translations:any;
	header:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    zones:any;
    totals:any;
    kpis:any;

    scrollableCols:any;
    frozenCols:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'ReportSalesPerClient/Post';
        this.header = {};
        this.zones = [];
        this.rows = [];
        this.totals = [];
        this.kpis = {};
    }

    ngOnInit() {
        /*this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;*/
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
              this.translations = translations;
              super.ngOnInit();
              this.getList();
        });

        this.getZonesData().subscribe(x => {
            if(x != false){
                this.zones = x;
            }
        });

        this.scrollableCols = [
            { field: 'idCliente', header: 'COD SAP', sortable:true, sortfield:'idCliente', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'ciudad', header: 'CIUDAD', sortable:true, sortfield:'ciudad', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'tipologia', header: 'TIPOLOGIA', sortable:true, sortfield:'tipologia', styleC:{'text-align':'center'}, width:{'width.px': 250}, isColor:false, pre:'', pos:'', total:''},
            { field: 'abc', header: 'ABC VTA', sortable:true, sortfield:'abc', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:true, pre:'', pos:'', total:''},
            { field: 'cupo', header: 'CUPO', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:''},
            { field: 'cupoDisponible', header: 'CUPO DISP', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:''},
            { field: 'status', header: 'STATUS CR', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 100}, isColor:false, pre:'', pos:'', total:''},
            { field: 'ventaNeta', header: 'VTA NETA', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:'netSales'},
            { field: 'sFechaUltVenta', header: 'F. ULT VTA', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'vtaPromMesAnio', header: 'VTA PROM MES AÑO X-1', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:'averageSalesMonthYear'},
            { field: 'variacion', header: '$ VAR', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:'var'},
            { field: 'promedioVariacion', header: '% VAR', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 100}, isColor:true, pre:'', pos:'%', total:'varPercent', colorClass:'varcolorClass'},
            { field: 'devolucion', header: 'DEVOLUCION', sortable:false, sortfield:'', styleC:{'text-align':'right'}, width:{'width.px': 200}, isColor:false, pre:'$', pos:'', total:'return'},
            { field: 'promedioDevolucion', header: '% DEV/VTA NETA', sortable:false, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:true, pre:'', pos:'%', total:'returnBySales', colorClass:'devcolorClass'}
        ];

        this.frozenCols = [
            { field: 'nombreCliente', header: 'NOM_CLIE', sortable:true, sortfield:'nombreCliente', styleC:{'text-align':'center'}, width:{'width.px': 350}, isColor:false, pre:'', pos:'', total:''}
        ];
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.kpis = {};
    }

    public getList(){
        var qst = this.read_url; 
        var obj:any;
        //this.f_datefrom = '2020-10-01';
        this.clearData();

        obj = {
            Zone: null,
            //Date: this.f_datefrom
            Date: this.f_datefrom + '-01'
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                //console.log(rs);
                this.header = rs.header;
                this.totals = rs.detail.totals;
                this.rows = rs.detail.salesByClient;
                this.kpis = rs.detail.salesPerClientKPIs;

                this.rows.forEach(r => {
                    let checker = parseFloat(r.promedioVariacion.replace(/,/g, ''));
                	if(checker <= 0){
                		//red
                		r.varcolor = '#ff0000';
                        r.varcolorFont = '#c8c8c8';
                		r.varcolorClass = 'orangered';
                	}
                	else if(checker > 5){
                		//green
                		r.varcolor = '#adff2f';
                        r.varcolorFont = '#000';
                		r.varcolorClass = 'greenyellow';
                	}
                	else{
                		//yellow
                		r.varcolor = '#ffff00';
                        r.varcolorFont = '#000';
                		r.varcolorClass = 'yellow';
                	}

                	checker = parseFloat(r.promedioDevolucion.replace(/,/g, ''));
                    if(checker > 3){
                		//red
                		r.devcolor = '#ff0000';
                        r.devcolorFont = '#c8c8c8';
                		r.devcolorClass = 'orangered';
                	}
                	else if(checker <= 1){
                		//green
                		r.devcolor = '#adff2f';
                        r.devcolorFont = '#000';
                		r.devcolorClass = 'greenyellow';
                	}
                	else{
                		//yellow
                		r.devcolor = '#ffff00';
                        r.devcolorFont = '#000';
                		r.devcolorClass = 'yellow';
                	}
                });
            }
        });
    }

    public getZonesData(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    getPdfReportHeader(){
        var obj = [];

        obj.push([{content:'REPORTE VENTA ACUMULADA POR CLIENTE (VENDEDOR)', colSpan:4, styles:{fontStyle:'bold', halign:'center'}}]);
        obj.push([
            {content:'Vendedor: ' + this.header['agent'], colSpan:2},
            {content:'Fecha: ' + this.today, colSpan:2}
        ]);
        obj.push([
            {content:'Supervisor: ' + this.header['supervisor'], colSpan:2},
            {content:'Mes: ' + this.curr_date, colSpan:2}
        ]);

        return obj;
    }

    exportReport(){
        var doc = new jsPDF('l','pt', 'a4');
        autoTable(doc, {body: this.getPdfReportHeader(), theme:'grid'});

        let header = [];
        let header_kpis = [['INDICADORES', 'CLIENTE']];
        let footer = [];
        let x = [];

        header = [];
        header.push(['NOM_CLIE', 'COD SAP', 'CIUDAD', , 'TIPOLOGIA', 'ABC VTA', 'CUPO', 'CUPO DISP', 'STATUS CR', 'VTA NETA', 'F. ULT VTA', 'VTA PROM MES AÑO X-1', '$ VAR        ', '% VAR      ', 'DEVOLUCION', '%DEV/VTA NETA']);
        
        x = [];
        this.rows.forEach(i => {
            x.push([
                i.nombreCliente,
                {content: i.idCliente, styles:{halign:'center'}},
                {content: i.ciudad, styles:{halign:'center'}},
                {content: i.tipologia, styles:{halign:'center'}},
                {content: i.abc, styles:{halign:'center'}},
                {content: '$'+i.cupo, styles:{halign:'right'}},
                {content: '$'+i.cupoDisponible, styles:{halign:'right'}},
                {content: i.status, styles:{halign:'center'}},
                {content: '$'+i.ventaNeta, styles:{halign:'right'}},
                {content: i.sFechaUltVenta, styles:{halign:'center'}},
                {content: '$'+i.vtaPromMesAnio, styles:{halign:'right'}},
                {content: '$'+i.variacion, styles:{halign:'right'}},
                {content:i.promedioVariacion + ' %', styles:{fillColor:i.varcolor, textColor: i.varcolorFont, halign:'center'}},
                {content: '$'+i.devolucion, styles:{halign:'right'}},
                {content:i.promedioDevolucion + ' %', styles:{fillColor:i.devcolor, textColor: i.devcolorFont, halign:'center'}}
            ]);
        });

        footer = [];
        footer.push([
        	{content:'TOTAL CIUDAD', colSpan:8},
            {content: '$'+this.totals.netSales, styles:{halign:'right'}},
            '',
            {content: '$'+this.totals.averageSalesMonthYear, styles:{halign:'right'}},
            {content: '$'+this.totals.var, styles:{halign:'right'}},
            {content: this.totals.varPercent + ' %', styles:{halign:'center'}},
            {content: '$'+this.totals.return, styles:{halign:'right'}},
            {content: this.totals.returnBySales + ' %', styles:{halign:'center'}}
        ]);

        autoTable(doc, {head:header, body: x, foot: footer, headStyles:{fontSize:7, fillColor:'#3e5569', halign:'center'}, bodyStyles:{fontSize:7}, footStyles:{fontSize:7, fillColor:'#e9ecef', textColor:'#000'}});

        //KPIs
        let boldstyle = {textColor:'#000',fontStyle:'bold', halign:'left'};
        let totalstyle = {textColor:'#000',fontStyle:'bold', fillColor:'#e9ecef', halign:'left'};
        let totalstyle2 = {textColor:'#000',fontStyle:'bold', fillColor:'#e9ecef'};

        x = [];
        x.push([{content:'No de clientes ASIGNADOS', styles:boldstyle}, this.kpis.numberOfActiveClients]);
        x.push([{content:'No de clientes BLOQUEADOS', styles:boldstyle}, this.kpis.numberOfBlockedClients]);
        x.push([{content:'% CLIENTES BLOQUEADOS', styles:totalstyle}, {content:this.kpis.blockedClientsPercent, styles:totalstyle2}]);

        x.push([{content:'No de clientes ASIGNADOS', styles:boldstyle}, this.kpis.numberOfEnableClients]);
        x.push([{content:'Clientes CON VENTA', styles:boldstyle}, this.kpis.customersWithSales]);
        x.push([{content:'% EFECTIVIDAD VENTA MES', styles:totalstyle}, {content:this.kpis.salesEffectivenessPerMonth, styles:totalstyle2}]);

        x.push([{content:'Vta Neta PERIODO', styles:boldstyle}, '$ '+this.kpis.netSalePeriod]);
        x.push([{content:'Obj Vta PERIODO', styles:boldstyle}, '$ '+this.kpis.goalSalePeriod]);
        x.push([{content:'% CUMPLIMIENTO VENTAS', styles:totalstyle}, {content:this.kpis.salesGoalPercentage, styles:totalstyle2}]);


        autoTable(doc, {head:header_kpis, body:x, bodyStyles:{halign:'right'}, headStyles:{fillColor:'#e9ecef', textColor:'#000', halign:'center'}, theme:'grid'});
        
        //Page Header and Footer
        doc = this.addPagesHeaderAndFooter(doc);
        doc.save('venta_acumulada_por_cliente_' + this.curr_date);
    }

    addPagesHeaderAndFooter(doc:any) {
        var totalPages = doc.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.addImage(Global.logo_base64, 'PNG', 710, 10, 90, 20);

            // Footer
            var str = 'Página ' + i + ' de ' + totalPages;
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
            doc.text(str, 40, pageHeight - 10);
        }

        return doc;
    }

}
